/**
 * SSE `event: keepalive` — bağlantı canlı tutmak için; metne eklenmemeli.
 * `\n\n` olmadan `event:keepaliveevent:keepalive## ...` gibi yapışık gelirse markdown başlığı bozulur; bu kalıbı metinden sökeriz.
 */
const KEEPALIVE_BLOCK = /(?:event:\s*keepalive)+/gi;

export function stripSseKeepaliveNoise(s: string): string {
  return s.replace(KEEPALIVE_BLOCK, "");
}
